// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__3saiD","alert":"SettungsInbox_alert__2rJRF"};